module.exports = __webpack_public_path__ + "static/media/banner-desktop.32a4374b.png";